module.exports = __webpack_public_path__ + "media/images/posts/sedvietas-b1ce5d441992bdb685b5f759a5773e76.jpg";